import { render, staticRenderFns } from "./boolean-input.vue?vue&type=template&id=b63c5576&lang=pug&"
import script from "./boolean-input.vue?vue&type=script&lang=ts&"
export * from "./boolean-input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports